import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { sessionStore, type SessionStore } from '../../api/session';
import { links } from '../../app/links';
import { flowStepOf } from './flowUrl';

/**
 * Cuando el API rechaza la sesión de un cliente (caducó o se revocó), abre el ingreso (C02) encima de
 * la landing y, al entrar, vuelve a la pantalla donde estaba (`next`). No actúa si el cliente cerró
 * sesión por su cuenta (eso no llama a `expire`), si ya hay un registro abierto ni con las sesiones
 * de estación o administración (tienen su propia pantalla de ingreso).
 */
export function useSessionExpiredPrompt(store: SessionStore = sessionStore): void {
  const navigate = useNavigate();
  const location = useLocation();
  const here = useRef(location);
  useEffect(() => {
    here.current = location;
  }, [location]);

  useEffect(
    () =>
      store.onExpired((user) => {
        if (user.role !== 'CLIENT') return;
        const { pathname, search, hash } = here.current;
        if (flowStepOf(new URLSearchParams(search)) !== null) return;
        // En la landing no hay a dónde volver: tras entrar se va al mapa, como con "Únete"
        const next = pathname === '/' ? undefined : `${pathname}${search}${hash}`;
        navigate(links.loginExpired(next));
      }),
    [store, navigate],
  );
}
